import { makeStyles } from "@mui/styles";

const useStyle = makeStyles((theme) => ({
  companyLogo: {
    "&.MuiAvatar-root": {
      width: 46,
      height: 46,
      backgroundColor: "gray",
      border: "0.3px solid lightgray",
      "& .MuiAvatar-img": {
        backgroundColor: theme.palette.common.white,
        
      },
      "& .MuiSvgIcon-root": {
        fontSize: 60,
      },
    },
  },
  uploadBtn: {
    "&.MuiButton-root": {
      paddingInline: "5px",
      marginBlock: "6px",
      marginLeft: "5px",
    },
  },
}));

export default useStyle;